import * as Const from '../../shared/constants';

import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

// services
import { EntradasService } from 'src/app/services/datos/entradas.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ArticulosService } from 'src/app/services/datos/articulos.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// interfaces
import { IEntrada } from 'src/app/interfaces/entrada';
import { IArticulo } from 'src/app/interfaces/articulo';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';

// librerias
import Swal from 'sweetalert2';

@Component({
  selector: 'app-entrada-directa-detall',
  templateUrl: './entrada-directa-detall.component.html',
  styleUrls: ['./entrada-directa-detall.component.scss']
})
export class EntradaDirectaDetallComponent implements OnInit {


  // Usar constantes en el template
  Const = Const
  private id_entrada: number | null = null
  @ViewChild('txtUbicacion') txtUbicacion!: ElementRef;

  entrada: IEntrada = {}
  public articuloSelected: IArticulo = {}
  public articulosList: IArticulo[] = []
  public entradaForm: FormGroup = new FormGroup({});

  public enviado: boolean = false;
  public loading: boolean = false;

  constructor(
    private entradaSrv: EntradasService,
    public notifciSrv: NotificacionesService,
    private articulosSrv: ArticulosService,
    private usuarioSrv: UsuarioService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    // Suscribirse a los parámetros de la url, si envían id_entrada, cargar los datos de la entrada
    this.activatedRoute.params.subscribe(({ id_entrada }) => {
      this.id_entrada = id_entrada;
      console.log('__ngOnInit() id_entrada:', this.id_entrada);
      this.getEntrada();
    });


    this.entradaForm = this.fb.group({
      id_articulo: ['', Validators.required],
      cantidad: [1, [Validators.required, Validators.min(1), Validators.max(99999)]],
      ubicacion: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
    });

  }


  // Get entrada con detall
  getEntrada() {
    if (!this.id_entrada) {
      this.notifciSrv.aviso('error', 'Id de entrada no proporcionado');
      this.router.navigate(['/pda']);
      return
    }

    this.focoUbicacion();

    const opcionesList = { id: this.id_entrada }
    this.loading = true;

    this.entradaSrv.getLista(opcionesList).subscribe(resp => {
      console.log('__getEntrada() resp', resp);

      this.loading = false;
      if (resp.error) {
        this.notifciSrv.aviso('error', resp.mensaje);
        this.router.navigate(['/pda']);
        return
      }
      if (resp.data.length == 0) {
        this.notifciSrv.aviso('error', 'No existe entrada con ese id');
        this.router.navigate(['/pda']);
        return
      }
      if (resp.data[0].swEntradaDirecta !== '1') {
        this.notifciSrv.aviso('error', 'No se puede editar esta entrada desde PDA, no es una entrada directa');
        this.router.navigate(['/pda']);
        return
      }
      this.entrada = resp.data[0];
      console.log('__getEntrada() id_entrada:', this.id_entrada);
      console.log('__getEntrada():', this.entrada);

      this.getArticulosList();
    })
  }

  getArticulosList() {
    this.loading = true;
    const opcionesList: IListaOpciones = { id_cliente: this.entrada.id_cliente, swEntradasDirectas: '1' }
    this.articulosSrv.getListaFiltrada(opcionesList).subscribe(resp => {
      this.loading = false;
      if (resp.error) {
        this.notifciSrv.aviso('error', resp.mensaje);
        return
      }
      this.articulosList = resp.data;
      console.log('__getArticulosList():', this.articulosList);
      if (this.articulosList.length == 0) {
        this.notifciSrv.aviso('error', this.entrada.cliNombre + ' no tiene artículos para entrada directa');
      }
    })
  }

  idArticuloChange(event: any) {
    this.articuloSelected = this.articulosList.find(articulo => articulo.id == event.target.value) || {};
    this.focoUbicacion();
  }

  cerrarEntradaDirecta() {
    Swal.fire({
      title: 'Cerrar entrada',
      html: `
        <div class="text-left">
          <p>¿Seguro que quieres cerrar esta entrada directa con <b>${this.entrada.detall?.length || 0}</b> líneas?</p>
        </div>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, cerrar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.entradaSrv.cerrarEntradaDirecta(this.id_entrada!).subscribe(resp => {
          console.log('__cerrarEntrada() resp:', resp);
          this.loading = false;
          if (resp.error) {
            this.notifciSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notifciSrv.aviso('success', resp.mensaje);
          this.router.navigate(['/pda']);
        })
      }
    })
  }

  enviar() {
    // Insertar nueva línea de detalle de la entrada
    this.enviado = true;
    if (this.entradaForm.invalid) {
      return
    }

    // data: {id_entrada,id_articulo,cantidad,cod_ubicacion,pale,username}
    const data = {
      id_entrada: this.id_entrada,
      id_articulo: this.f['id_articulo'].value,
      cantidad: this.f['cantidad'].value,
      cod_ubicacion: this.f['ubicacion'].value,
      pale: '1',
      username: this.usuarioSrv.userdata.username,
    }

    this.loading = true;
    this.entradaSrv.addLineaEntradaDirecta(data).subscribe(resp => {
      console.log('__addLineaEntradaDirecta resp:', resp);
      this.loading = false;

      if (resp.error) {
        this.notifciSrv.aviso('error', resp.mensaje);
        for (let controlName in resp.mensaje) {
          this.entradaForm.get(controlName)!.setErrors({ 'apiError': resp.mensaje[controlName] });
        }
        return;
      }

      // Todo ok
      this.getEntrada();
      this.notifciSrv.aviso('success', resp.mensaje);

      this.enviado = false;
      this.resetForm();
    })
    return
  }




  ////// AUX ///// 

  get f() {
    return this.entradaForm.controls;
  }

  resetForm() {
    this.f['id_articulo'].setValue('');
    this.f['cantidad'].setValue(1);
    this.f['ubicacion'].setValue('');
  }

  toUpper(fieldName: string) {
    const formControl = this.f[fieldName];

    if (formControl && formControl.value) {
      formControl.setValue(formControl.value.toUpperCase());
    }
  }


  // Poner foco en el campo ubicacion
  focoUbicacion() {
    setTimeout(() => {
      this.txtUbicacion.nativeElement.focus();
    }, 500);
  }



}
